import { useEffect, useState } from "react";
import {
  getDayStr,
  getTimeStr,
  isoToFormatDate,
} from "../../../functions/formatTime";

import Row from "../../common/List/Row";
import {
  getPurposeStr,
  getRentingStatus,
} from "../../../functions/reservation";

const ReservationRow = ({ reservation, setShowPopUp, setCurReservation }) => {
  // when clicking row, show the pop up with reservation info
  const [user, setUser] = useState(null);

  const { deleted } = reservation;

  useEffect(() => {
    setUser(reservation.userId);
  }, []);

  const formatRoomNumber = (str) => {
    try {
      // last four digits
      return str.substring(str.length - 4, str.length);
    } catch (err) {
      console.error(err);
      return "ERROR";
    }
  };

  const showPopUp = () => {
    setCurReservation(reservation);
    setShowPopUp(true);
  };

  const cellTexts = [
    isoToFormatDate(reservation.startTime),
    getDayStr(reservation.startTime),
    getTimeStr(reservation.startTime, reservation.endTime),
    getPurposeStr(reservation.purpose),
    formatRoomNumber(reservation.roomNumber),
    user?.memberNumber,
    user?.name,
    user?.phoneNumber,
    getRentingStatus(user?.isRenter),
    user?.profession,
  ];

  const noteTexts = [
    reservation.userNote,
    reservation.deleted ? `(已刪除)${reservation.note}` : reservation.note,
  ];

  const cellAlign = ["C", "C", "C", "C", "C", "C", "L", "L"];

  if (deleted) {
    return (
      <Row
        cellTexts={cellTexts}
        noteTexts={noteTexts}
        showPopUp={showPopUp}
        className="text-gray-200"
        cellAlign={cellAlign}
      />
    );
  }

  return (
    <Row
      cellTexts={cellTexts}
      noteTexts={noteTexts}
      showPopUp={showPopUp}
      cellAlign={cellAlign}
    />
  );
};

export default ReservationRow;
